import withCacheRequest from '../decorators/withCacheRequest';
import AjaxUtils from './ajaxUtils';
const EXP_TTL = 120; // ttl for cache
const contactSearchFiltersData = () => withCacheRequest('ContactSearchFilters', EXP_TTL, () => AjaxUtils.get('/v2/search-filters'));
export { contactSearchFiltersData };
